export default __webpack_public_path__ + "static/media/ProximaNova-Extrabold.c9d202c8.otf";